import React from "react";

// External package
import Carousel from "react-multi-carousel";

// source
import { projectTools } from "../../source/serviceFeaturesSource";
import { useTranslation } from "../../i18n";
export default function DescribeMeComponents() {
  const { t } = useTranslation();
  const responsiveTools = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 5,
    },
  };

  return (
    <div className="describe_me">
      {t.about.describe.map((paragraph, index) => (
        <p
          key={index}
          className={`font-vietnam-300 ${
            index === 0 ? "first-letter-capital" : ""
          }`}
        >
          {paragraph}
        </p>
      ))}
      <div className="tools-project">
        <label htmlFor="" className="font-size-36 font-vietnam-600">
          {t.about.tools}
        </label>
        <div className="tools-project_images">
          <Carousel
            responsive={responsiveTools}
            autoPlaySpeed={2000}
            autoPlay={true}
            infinite={true}
            ssr={true}
            arrows={false}
          >
            {projectTools.map((tool) => (
              <div
                key={tool.id}
                data-aos="zoom-in"
                data-aos-anchor-placement="top-center"
                data-aos-duration={"1" + tool.id * 1000}
              >
                <img src={tool.image} alt={tool.title} loading="lazy" />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}
